import api from "../../utils/apiCliente";
import { desempaquetarLista } from "../../utils/listaPaginada";

export const getPerfilCliente = async () => {
  const res = await api.get("/api/cliente/perfil/perfil");
  return res.data;
};

export const getDireccionesCliente = async () => {
  const res = await api.get("/api/cliente/perfil/direcciones");
  return res.data;
};

export const getPedidosCliente = async ({ limit = 200, offset = 0 } = {}) => {
  const res = await api.get("/api/cliente/perfil/pedidos", { params: { limit, offset } });
  return desempaquetarLista(res.data).items;
};

export const getPedidoDetalleCliente = async (pedidoId) => {
  const res = await api.get(`/api/cliente/perfil/pedidos/${pedidoId}/detalle`);
  return res.data;
};

export const updatePerfilCliente = async (payload) => {
  const res = await api.put("/api/cliente/perfil/perfil/update", payload);
  return res.data;
};

export const changePasswordCliente = async (payload) => {
  const res = await api.put("/api/cliente/perfil/perfil/password", payload);
  return res.data;
};

export const createDireccionCliente = async (payload) => {
  const res = await api.post("/api/cliente/perfil/direcciones", payload);
  return res.data;
};

export const updateDireccionCliente = async (id, payload) => {
  const res = await api.put(`/api/cliente/perfil/direcciones/${id}`, payload);
  return res.data;
};

export const deleteDireccionCliente = async (id) => {
  const res = await api.delete(`/api/cliente/perfil/direcciones/${id}`);
  return res.data;
};